import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { BaseFormComponent } from '../../../../core/layout/components/abstracts/base-form.component';
import { FormFields } from '../../../../core/types';
import { ICardFreeEntryItem } from '../../core/interfaces/ICardFreeEntryItem';
import { ICard } from '../../core/interfaces/ICard';
import { CardsService } from '../../core/services/CardsService';
import { FormControlComponent } from '../../../../shared/components/form-control/form-control.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectComponent } from '../../../../shared/components/select/select.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { StepperComponent } from '../../../../shared/components/stepper/stepper.component';
import { DatepickerComponent } from '../../../../shared/components/datepicker/datepicker.component';
import { CardsStore } from '../../core/stores/CardsStore';
import { IdAndNamePipe } from '../../../../shared/pipes/id-and-name.pipe';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import dayjs from 'dayjs';
import { DayjsPipe } from '../../../../shared/pipes/dayjs.pipe';

@Component({
  selector: 'app-add-edit-free-entry-form',
  standalone: true,
  imports: [
    FormControlComponent,
    FormsModule,
    ReactiveFormsModule,
    SelectComponent,
    TranslatePipe,
    StepperComponent,
    DatepickerComponent,
    IdAndNamePipe,
    DayjsPipe
  ],
  templateUrl: './add-edit-free-entry-form.component.html',
  styleUrl: './add-edit-free-entry-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddEditFreeEntryFormComponent extends BaseFormComponent<ICardFreeEntryItem> {

  @Input({ required: true }) isAdd: boolean;
  @Input({ required: true }) card: ICard;

  public readonly minValidFrom = dayjs();
  public readonly issuers = inject(CardsStore).issuers;

  protected override readonly formFields: FormFields = {
    freeEntryId: new FormControl(null),
    firmId: new FormControl(null),
    count: new FormControl(1),
    validFrom: new FormControl(null),
    validUntil: new FormControl(null),
  };

  private readonly _cardsService = inject(CardsService);

  protected override formValidActions(): void {
    if (this.isAdd) {
      this._cardsService.addFreeEntries(this.card.cardId, this.form.value)
        .pipe(
          finalize(() => this.unlockForm())
        )
        .subscribe({
          next: res => this.formFinished.emit(res.data),
          error: ({ error }: ApiErrorResponse) => {
            this.notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`add-free-entries/notifications/${error.message}.Message`)
            );
          }
        });
    }
  }
}
